import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { auth } from '../../config/firebase';
import { usePermissions } from '../utils/AclProvider';
import { getNestedObject } from '../../utils/utils';

const AuthChecker = ({ children, requiredPermission }) => {
  const navigate = useNavigate();
  const permissions = usePermissions();
  // const user = useUser();

  useEffect(() => {
    if (!auth.currentUser) {
      navigate('/login');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  //
  // if (!user) {
  //   return <Navigate to="/login" />;
  // }

  if (requiredPermission && !getNestedObject(permissions, requiredPermission)) {
    // console.log('requiredPermission', requiredPermission, permissions[requiredPermission]);
    return <Navigate to="/unauthorized" />;
  }

  return <>{children}</>;
};

export default AuthChecker;
